import {
    BAY_TABLE_DATA_CALL_BEGIN,
    BAY_TABLE_DATA_CALL_FAILURE,
    BAY_TABLE_DATA_CALL_SUCCESS, BAY_TABLE_DATA_CLEAR,
    INDUCT_CALL_BEGIN,
    INDUCT_CALL_FAILURE,
    INDUCT_CALL_SUCCESS,
    MACHINE_STATUS_CALL_BEGIN,
    MACHINE_STATUS_CALL_FAILURE,
    MACHINE_STATUS_CALL_SUCCESS,
    MACHINE_TABLE_DATA_CALL_BEGIN, MACHINE_TABLE_DATA_CALL_FAILURE,
    MACHINE_TABLE_DATA_CALL_SUCCESS, PLANNED_COUNT_CALL_BEGIN, PLANNED_COUNT_CALL_FAILURE, PLANNED_COUNT_CALL_SUCCESS
} from "../actions/StowBufferAction";

const initialState =  {
    inductCount: '',
    loading: false,
    machineList:[],
    stowPackageMetrics: {},
    bayList:[],
    machineStatusList: []
}

const stowBufferReducer = (state = initialState , action) => {
    switch (action.type) {
        case INDUCT_CALL_BEGIN:
            return {
                ...state,
                loading:true
            }
        case INDUCT_CALL_SUCCESS:
            return {
                ...state,
                inductCount: action.inductCount,
                loading:false
            }
        case INDUCT_CALL_FAILURE:
            return {
                ...state,
                loading: false
            }
        case MACHINE_STATUS_CALL_BEGIN:
            return {
                ...state,
                loading:true
            }
        case MACHINE_STATUS_CALL_SUCCESS:
            return {
                ...state,
                machineStatusList: action.machineStatusList,
                loading:false
            }
        case MACHINE_STATUS_CALL_FAILURE:
            return {
                ...state,
                loading: false
            }
        case BAY_TABLE_DATA_CALL_BEGIN:
            return {
                ...state,
                loading:true
            }
        case BAY_TABLE_DATA_CLEAR:
            return {
                ...state,
                bayList: []
            }
        case BAY_TABLE_DATA_CALL_SUCCESS:
            return {
                ...state,
                bayList: action.bayList,
                loading:false
            }
        case BAY_TABLE_DATA_CALL_FAILURE:
            return {
                ...state,
                loading: false
            }
        case MACHINE_TABLE_DATA_CALL_BEGIN:
            return {
                ...state,
                loading: true
            }
        case MACHINE_TABLE_DATA_CALL_SUCCESS:
            return {
                ...state,
                machineList: action.machineList,
                loading: false
            }
        case MACHINE_TABLE_DATA_CALL_FAILURE:
            return {
                ...state,
                loading: false
            }
        case PLANNED_COUNT_CALL_BEGIN:
            return {
                ...state,
                loading: true
            }
        case PLANNED_COUNT_CALL_SUCCESS:
            return {
                ...state,
                stowPackageMetrics: action.stowPackageMetricsMap,
                loading: false
            }
        case PLANNED_COUNT_CALL_FAILURE:
            return {
                ...state,
                loading: false
            }
        default:
            return state
    }
}

export default stowBufferReducer



// WEBPACK FOOTER //
// ./src/reducers/StowBufferReducer.js